import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Shield, Briefcase, UserCheck } from 'lucide-react';

export const HeroSection = () => {
  const features = [
    { icon: Shield, text: 'Identity Preserved' },
    { icon: UserCheck, text: 'Professional Grade' },
    { icon: Briefcase, text: 'Recruiter-Ready' },
  ];

  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted/30" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary mb-6">
            <Camera className="w-4 h-4" />
            <span className="text-sm font-medium">AI-Powered Profile Photo Enhancer</span>
          </div>
          
          {/* Main heading */}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
            Professional Profile Picture
            <span className="block mt-2">
              <span className="text-foreground">Generator by </span>
              <span className="gradient-text">Growleads.io</span>
            </span>
          </h1>
          
          {/* Subheading */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
            Transform your photo into a LinkedIn-ready professional headshot. 
            Studio-quality results that build trust and credibility with recruiters and clients.
          </p>
          
          {/* Feature pills */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.2 + index * 0.1 }}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-card border border-border shadow-sm"
              >
                <feature.icon className="w-4 h-4 text-primary" />
                <span className="text-sm text-foreground font-medium">{feature.text}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
